import { ContractStatusVariants, ContractActions, ContractTypes } from '@/modules/logito/office/inc/contracts/settings';

const contractStatusVariant = (key: string): any =>
    ContractStatusVariants().find((item: any) => item.key === key)?.value;
const contractAction = (key: string): any => ContractActions().find((item: any) => item.key === key)?.value;
const contractTypes = (key: string): any => ContractTypes().find((item: any) => item.key === key)?.value;

export { contractStatusVariant, contractAction, contractTypes };
